import React from "react";
import { MarkdownRenderer } from "@/components/feature/markdown/markdownRenderer";
import { reformatCitations } from "@/modules/chat/chat.utils";
import { ProgressIndicator } from "./progressIndicator";

interface Props {
  typedContent: string;
  progressPercentage: number;
}

export const TypewriterContent: React.FC<Props> = ({ typedContent, progressPercentage }) => (
  <div className="relative text-sm leading-relaxed">
    <div className="relative">
      <MarkdownRenderer content={reformatCitations(typedContent)} evidences={[]} processCitations={true} />
      {/* Blinking cursor */}
      <span className="ml-0.5 inline-block h-4 w-0.5 animate-pulse bg-coral" />
    </div>

    {/* Progress indicator */}
    <ProgressIndicator progressPercentage={progressPercentage} />
  </div>
);
